<template>
	<div class="selected-payment" :class="methodName">
		<iframe v-if="authorizedUrl" class="iframe-container" :src="iframeURL" frameborder="0"></iframe>
	</div>
</template>

<script>
export default {
	name: 'SelectedPaymentMethod',
	computed: {
		methodName() {
			return this.$store.state.selectedPg && this.$store.state.selectedPg.methodName
				? this.$store.state.selectedPg.methodName
				: '';
		},
		authorizedUrl() {
			return this.$store.state.authorizedUrl;
		},
		iframeURL() {
			return this.authorizedUrl ? this.replaceUrlLocale(this.authorizedUrl, 2) : null;
		},
		isIngamePurchase() {
			return this.$route.name === 'in-game-purchase' || this.$store.state.appType === 'game';
		},
	},
	created() {
		window.addEventListener('message', this.receivedIframeMessage);
	},
	beforeDestroy() {
		window.removeEventListener('message', this.receivedIframeMessage);
	},
	methods: {
		receivedIframeMessage(message) {
			if (message && message.data) {
				if (message.data.selectedAmount) {
					this.$store.commit('setKarmakoinSelectedOption', message.data.selectedAmount);
				} else if (message.data.action && message.data.action === 'change-method') {
					this.$store.commit('setKarmakoinSelectedOption', null);
					this.$store.commit('setShowSelectedPg', false);
					this.$store.commit('setSelectedPg', null);
				} else if (message.data.eventType === 'error') {
					if (this.isIngamePurchase) {
						dataLayer.push({
							event: 'In Game Purchase Failure',
							IGP_sufficient: false,
							...(message.data.methodName ? { IGP_paymentGateway: message.data.methodName } : {}),
							IGP_error: message.data.error,
						});
					} else {
						dataLayer.push({
							event: 'Add Balance Error',
							'Add Balance Error Message': message.data.error,
						});
					}
				}
			}
		},
	},
};
</script>

<style lang="less" scoped>
.selected-payment {
	height: 550px;
	.iframe-container {
		width: 100%;
		height: 100%;
		background-color: transparent;
		border: none;
	}
	&.paysafecard {
		height: 760px;
	}
	&.skrill {
		height: 800px;
	}
	&.mol_12call,
	&.mol_truemoney {
		height: 450px;
	}
}
</style>
